import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dcb84d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_3 = { class: "sm:col-span-4 main-content" }
const _hoisted_4 = {
  key: 0,
  class: "question-label question-label-project2"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "w-64 justify-items-stretch flex flex-col mb-4" }
const _hoisted_9 = { class: "sm:col-span-4 flex-col justify-center items-center flex min-h-full" }
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_ctx.config.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_t, _ctx.config.title]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              class: "mt-4",
              innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_5),
            (_ctx.config.textPart2)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "mt-4",
                  innerHTML: _ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (!_ctx.showQuestion)
              ? (_openBlock(), _createBlock(_component_ActionButton, {
                  key: 2,
                  text: "buttons.see",
                  class: "mt-16 action-button-project2 mx-auto sm:mx-0 block",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showQuestion = true))
                }))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", {
              class: "mt-8 mb-4 facts-label",
              style: _normalizeStyle(`background: ${_ctx.config.image1} center left no-repeat; background-size: contain;`)
            }, [
              _createElementVNode("p", {
                class: "max-w-xs p-4 text-lg text-white font-normal",
                innerHTML: _ctx.$t(_ctx.config.question, {name: _ctx.state.nickname.value})
              }, null, 8, _hoisted_7)
            ], 4), [
              [_vShow, _ctx.showQuestion]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.options, (option, key) => {
                return (_openBlock(), _createBlock(_component_ActionButton, {
                  key: key,
                  class: "mb-4",
                  "button-class": "answer-button answer-button-project2",
                  onClick: ($event: any) => (_ctx.answer(key, {[key]: _ctx.$t(option)})),
                  rawtext: _ctx.$t(option)
                }, null, 8, ["onClick", "rawtext"]))
              }), 128))
            ], 512), [
              [_vShow, _ctx.showQuestion]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: _ctx.config.bgImage,
              class: "max-h-75vh h-auto"
            }, null, 8, _hoisted_10)
          ])
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}